<!-- @format -->

<a
	[href]="data.link"
	[attr.data-em]="createTag(data.linkTitle)"
	[ngClass]="ctaType"
	[target]="data.link.indexOf('://') > 0 || data.link.indexOf('//') === 0 ? '_blank' : '_self'"
	class="cta">
	{{ data.linkTitle }}
	<homefield-icon
		*ngIf="chevron"
		class="material-icons"
		name="arrow-right"></homefield-icon>
</a>
